// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Link} from "react-router-dom";
import {Button, Checkbox, Col, Form, Input, Result, Row, Spin} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import * as AuthBackend from "../../services/AuthBackend";
import * as ApplicationBackend from "../../services/ApplicationBackend";
import * as Provider from "../../widget/Provider";
import * as Util from "../../utils/Util";
import * as Setting from "../../conf/Setting";
import {GithubLoginButton, GoogleLoginButton} from "react-social-login-buttons";
import FacebookLoginButton from "../../components/3rdLoginButton/FacebookLoginButton";
import QqLoginButton from "../../components/3rdLoginButton/QqLoginButton";
import DingTalkLoginButton from "../../components/3rdLoginButton/DingTalkLoginButton";
import GiteeLoginButton from "../../components/3rdLoginButton/GiteeLoginButton";
import WechatLoginButton from "../../components/3rdLoginButton/WechatLoginButton";
import WeiboLoginButton from "../../components/3rdLoginButton/WeiboLoginButton";
import i18next from "i18next";
import LinkedInLoginButton from "../../components/3rdLoginButton/LinkedInLoginButton";
import WeComLoginButton from "../../components/3rdLoginButton/WeComLoginButton";
import LarkLoginButton from "../../components/3rdLoginButton/LarkLoginButton";
import GitLabLoginButton from "../../components/3rdLoginButton/GitLabLoginButton";
import AdfsLoginButton from "../../components/3rdLoginButton/AdfsLoginButton";
import BaiduLoginButton from "../../components/3rdLoginButton/BaiduLoginButton";
import AlipayLoginButton from "../../components/3rdLoginButton/AlipayLoginButton";
import CasdoorLoginButton from "../../components/3rdLoginButton/CasdoorLoginButton";
import InfoflowLoginButton from "../../components/3rdLoginButton/InfoflowLoginButton";
import AppleLoginButton from "../../components/3rdLoginButton/AppleLoginButton";
import AzureADLoginButton from "../../components/3rdLoginButton/AzureADLoginButton";
import SlackLoginButton from "../../components/3rdLoginButton/SlackLoginButton";
import SteamLoginButton from "../../components/3rdLoginButton/SteamLoginButton";
import CustomGithubCorner from "../../components/common/CustomGithubCorner";
import {CountDownInput} from "../../components/common/CountDownInput";
import {JSEncrypt} from "jsencrypt";
import SelectLanguageBox from "../../components/common/SelectLanguageBox";
import * as PasswordPolicyBackend from "../../services/PasswordPolicyBackend";
import Captcha from "../../components/common/Captcha";
import GlobalContext from "../../context/GlobalContext";
import iconfont from "../../assets/font/appfonts/iconfont.json";
import * as IconFont from "../../components/common/IconFont";

const isSmallScreen = window.screen.availWidth <= 1366 ? true : false;

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      type: props.type,
      applicationId:
        props.applicationId !== undefined
          ? props.applicationId
          : props.match === undefined
            ? null
            : props.match.params.applicationId,
      owner:
        props.owner !== undefined
          ? props.owner
          : props.match === undefined
            ? null
            : props.match.params.owner,
      application: null,
      mode:
        props.mode !== undefined
          ? props.mode
          : props.match === undefined
            ? null
            : props.match.params.mode, // "signup" or "signin"
      isCodeSignin: false,
      isPasswordSignin: true,
      isPhoneSignin: false,
      isEmailSignin: false,
      msg: null,
      username: null,
      validEmailOrPhone: false,
      validEmail: false,
      validPhone: false,
      casParamException: false,
    };

    if (this.state.type === "cas" && props.match?.params.casApplicationName !== undefined) {
      this.state.owner = props.match?.params.owner;
      this.state.applicationId = props.match?.params.casApplicationName;

      const casParams = Util.getCasParameters();
      if (casParams.service === "") {
        this.state.casParamException = true;
      }
    }
  }
  formRef = React.createRef();
  captchaRef = React.createRef();

  isMobile() {
    return Setting.isMobile();
    // return navigator.userAgent.match(/(iphone|iPod|Android|ios|iPad|AppleWebKit.*Mobile.*)/i);
  }

  UNSAFE_componentWillMount() {
    if (this.state.type === "login" || this.state.type === "cas") {
      this.getApplication();
    } else if (this.state.type === "code") {
      this.getApplicationLogin();
    } else if (this.state.type === "saml") {
      this.getSamlApplication();
    } else {
      Util.showMessage("error", `Unknown authentication type: ${this.state.type}`);
    }
  }

  getApplicationLogin() {
    const oAuthParams = Util.getOAuthGetParameters();
    AuthBackend.getApplicationLogin(oAuthParams)
      .then((res) => {
        if (res.status === "ok") {
          this.setState({
            application: res.data,
          });
          window.localStorage.setItem("__APPLICATION__", JSON.stringify(res.data));
        } else {
        // Util.showMessage("error", res.msg);
          this.setState({
            application: res.data,
            msg: res.msg,
          });
        }
      });
  }

  getApplication() {
    if (this.state.applicationId === null) {
      return;
    }

    ApplicationBackend.getApplicationById(Setting.Admin, this.state.applicationId).then((res) => {
      if (res.msg !== undefined) {
        Setting.showResponseMessage(res.msg);
      } else {
        // 重置logo图片
        this.setState({
          application: res,
        });
        window.localStorage.setItem("__APPLICATION__", JSON.stringify(res));
      }
    });
  }

  getSamlApplication() {
    if (this.state.applicationId === null) {
      return;
    }
    ApplicationBackend.getApplication(this.state.owner, this.state.applicationId)
      .then((application) => {
        this.setState({
          application: application,
        });
        window.localStorage.setItem("__APPLICATION__", JSON.stringify(application));
      }
      );
  }

  getApplicationObj() {
    if (this.props.application !== undefined) {
      return this.props.application;
    } else {
      return this.state.application;
    }
  }

  onUpdateAccount(account) {
    this.props.onUpdateAccount(account);
  }

  onFinish(formValues, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, captchaPass = true, user = undefined) {
    const application = this.getApplicationObj();
    const ths = this;

    if (this.state.isPasswordSignin && !captchaPass) {
      this.captchaRef.current.getCaptcha();
      return;
    }

    const values = Setting.deepCopy(formValues);

    AuthBackend.getPublicKey().then(resPubKey => {
      if (resPubKey.status === "ok") {
        // 密码加密
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(resPubKey.msg);
        values["password"] = encrypt.encrypt(values["password"]);
        if (values["password"] === false) {
          values["password"] = "";
        }

        // here we are supposed to judge whether casdoor is working as a oauth server or CAS server
        if (ths.state.type === "cas") {
          // cas
          const casParams = Util.getCasParameters();
          values["type"] = ths.state.type;
          values["phonePrefix"] = this.getApplicationObj().organizationObj === null ? "" : this.getApplicationObj().organizationObj.phonePrefix;

          AuthBackend.loginCas(values, casParams).then((res) => {
            if (res.status === "ok") {
              let msg = i18next.t("login:Logged in successfully.");
              if (casParams.service === "") {
                // If service was not specified, CAS MUST display a message notifying the client that it has successfully initiated a single sign-on session.
                msg += i18next.t("login:Now you can visit apps protected.");
              }
              if (casParams.service !== "") {
                const st = res.data;
                try {
                  const newUrl = new URL(casParams.service);
                  newUrl.searchParams.append("ticket", st);
                  Util.showMessage("success", msg);
                  window.location.href = newUrl.toString();
                } catch (error) {
                  Setting.showMessage("error", error.message);
                }
              } else {
                Util.showMessage("success", msg);
              }
            } else {
              Util.showMessage(
                "error",
                Setting.getResponseMessage(res.msg)
              );
            }
          });
        } else {
          // oauth
          const oAuthParams = Util.getOAuthGetParameters();
          if (
            oAuthParams !== null &&
						oAuthParams.responseType !== null &&
						oAuthParams.responseType !== ""
          ) {
            values["type"] = oAuthParams.responseType;
          } else {
            values["type"] = this.state.type;
          }

          values["phonePrefix"] = this.getApplicationObj().organizationObj === null ? "" : this.getApplicationObj().organizationObj.phonePrefix;

          if (oAuthParams !== null) {
            values["samlRequest"] = oAuthParams.samlRequest;
          }

          if (values["samlRequest"] !== null && values["samlRequest"] !== "" && values["samlRequest"] !== undefined) {
            values["type"] = "saml";
          }

          AuthBackend.login(values, oAuthParams).then((res) => {
            if (res.status === "ok") {
              const password = values["password"];

              const responseType = values["type"];
              let username = ths.state.isPasswordSignin ? values["username"] : "";
              username = user !== undefined ? user : username;
              if (responseType === "login") {
                Util.showMessage("success", i18next.t("login:Logged in successfully."));

                PasswordPolicyBackend.checkPasswordNeedChange(application.organizationObj.owner, application.organizationObj.uid, application.organizationObj.uid, username, password)
                  .then(resCheck => {
                    const loginRedirectUri = Setting.getFromLink();
                    const pwdRemindRedirectUri = Util.encodeUrl(loginRedirectUri);
                    if (resCheck.data === true) {
                      Setting.goToLink(`/password/remind/${application.organizationObj.uid}/?msg=${JSON.stringify(resCheck.msg)}&skip=${resCheck.data2 === true ? 1 : 0}&redirect_uri=${pwdRemindRedirectUri}`);
                      updateSkipPasswordCheck(false);
                      updatePasswordCheckMsg(resCheck.msg);
                      if (resCheck.data2 === true) {
                        updateShipChangePassword(true);
                      }
                    } else if (resCheck.msg !== undefined && resCheck.msg !== "") {
                      Setting.getResponseMessage(resCheck.msg);
                    } else {
                      Setting.goToLink(loginRedirectUri);
                    }
                  });
              } else if (responseType === "code") {
                const code = res.data;
                const concatChar = oAuthParams?.redirectUri?.includes("?") ? "&" : "?";

                if (Setting.hasPromptPage(application)) {
                  AuthBackend.getAccount("").then((res) => {
                    let account = null;
                    if (res.status === "ok") {
                      account = res.data;
                      // 设置默认title
                      res.data2.displayName = "统一身份认证平台";
                      account.organization = res.data2;

                      PasswordPolicyBackend.checkPasswordNeedChange(application.organizationObj.owner, application.organizationObj.uid, application.organizationObj.uid, username, password)
                        .then(resCheck => {
                          let loginRedirectUri = "";
                          let pwdRemindRedirectUri = "";
                          if (Setting.isPromptAnswered(account, application)) {
                            loginRedirectUri = `${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`;
                            pwdRemindRedirectUri = Util.encodeUrl(loginRedirectUri);
                          } else {
                            loginRedirectUri = `/prompt/${application.uid}?redirectUri=${oAuthParams.redirectUri}&code=${code}&state=${oAuthParams.state}`;
                            pwdRemindRedirectUri = Util.encodeUrl(`${window.location.origin}/${loginRedirectUri}`);
                          }
                          if (resCheck.data === true) {
                            Setting.goToLink(`/password/remind/${application.organizationObj.uid}/?msg=${JSON.stringify(resCheck.msg)}&skip=${resCheck.data2 === true ? 1 : 0}&redirect_uri=${pwdRemindRedirectUri}`);
                            updateSkipPasswordCheck(false);
                            updatePasswordCheckMsg(resCheck.msg);
                            if (resCheck.data2 === true) {
                              updateShipChangePassword(true);
                            }
                          } else if (resCheck.msg !== undefined && resCheck.msg !== "") {
                            Setting.getResponseMessage(resCheck.msg);
                          } else {
                            if (Setting.isPromptAnswered(account, application)) {
                              Setting.goToLink(
                                `${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`
                              );
                            } else {
                              Setting.goToLink(
                                `/prompt/${application.uid}?redirectUri=${oAuthParams.redirectUri}&code=${code}&state=${oAuthParams.state}`
                              );
                            }
                          }
                        });
                    } else {
                      Setting.showMessage(
                        "error",
                        Setting.getResponseMessage(res.msg)
                      );
                    }
                  });
                } else {
                  PasswordPolicyBackend.checkPasswordNeedChange(application.organizationObj.owner, application.organizationObj.uid, application.organizationObj.uid, username, password)
                    .then(resCheck => {
                      const loginRedirectUri = `${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`;
                      const pwdRemindRedirectUri = Util.encodeUrl(loginRedirectUri);
                      if (resCheck.data === true) {
                        Setting.goToLink(`/password/remind/${application.organizationObj.uid}/?msg=${JSON.stringify(resCheck.msg)}&skip=${resCheck.data2 === true ? 1 : 0}&redirect_uri=${pwdRemindRedirectUri}`);
                        updateSkipPasswordCheck(false);
                        updatePasswordCheckMsg(resCheck.msg);
                        if (resCheck.data2 === true) {
                          updateShipChangePassword(true);
                        }
                      } else if (resCheck.msg !== undefined && resCheck.msg !== "") {
                        Setting.getResponseMessage(resCheck.msg);
                      } else {
                        Setting.goToLink(
                          loginRedirectUri
                        );
                      }
                    });
                }
                // Util.showMessage("success", `Authorization code: ${res.data}`);
              } else if (responseType === "token" || responseType === "id_token") {
                const accessToken = res.data;
                Setting.goToLink(
                  `${oAuthParams.redirectUri}#${responseType}=${accessToken}?state=${oAuthParams.state}&token_type=bearer`
                );
              } else if (responseType === "saml") {
                const SAMLResponse = res.data;
                const redirectUri = res.data2;
                Setting.goToLink(
                  `${redirectUri}?SAMLResponse=${encodeURIComponent(SAMLResponse)}&RelayState=${
                    oAuthParams.relayState
                  }`
                );
              }
            } else {
              Util.showMessage(
                "error",
                Setting.getResponseMessage(res.msg)
              );
            }
          });
        }
      } else {
        Setting.showResponseMessage(resPubKey.msg);
      }
    });
  }

  getSigninButton(type) {
    const text = i18next.t("login:Sign in with {type}").replace("{type}", type);
    if (type === "GitHub") {
      return <GithubLoginButton text={text} align={"center"} />;
    } else if (type === "Google") {
      return <GoogleLoginButton text={text} align={"center"} />;
    } else if (type === "QQ") {
      return <QqLoginButton text={text} align={"center"} />;
    } else if (type === "Facebook") {
      return <FacebookLoginButton text={text} align={"center"} />;
    } else if (type === "Weibo") {
      return <WeiboLoginButton text={text} align={"center"} />;
    } else if (type === "Gitee") {
      return <GiteeLoginButton text={text} align={"center"} />;
    } else if (type === "WeChat") {
      return <WechatLoginButton text={text} align={"center"} />;
    } else if (type === "DingTalk") {
      return <DingTalkLoginButton text={text} align={"center"} />;
    } else if (type === "LinkedIn") {
      return <LinkedInLoginButton text={text} align={"center"} />;
    } else if (type === "WeCom") {
      return <WeComLoginButton text={text} align={"center"} />;
    } else if (type === "Lark") {
      return <LarkLoginButton text={text} align={"center"} />;
    } else if (type === "GitLab") {
      return <GitLabLoginButton text={text} align={"center"} />;
    } else if (type === "Adfs") {
      return <AdfsLoginButton text={text} align={"center"} />;
    } else if (type === "Casdoor") {
      return <CasdoorLoginButton text={text} align={"center"} />;
    } else if (type === "Baidu") {
      return <BaiduLoginButton text={text} align={"center"} />;
    } else if (type === "Alipay") {
      return <AlipayLoginButton text={text} align={"center"} />;
    } else if (type === "Infoflow") {
      return <InfoflowLoginButton text={text} align={"center"} />;
    } else if (type === "Apple") {
      return <AppleLoginButton text={text} align={"center"} />;
    } else if (type === "AzureAD") {
      return <AzureADLoginButton text={text} align={"center"} />;
    } else if (type === "Slack") {
      return <SlackLoginButton text={text} align={"center"} />;
    } else if (type === "Steam") {
      return <SteamLoginButton text={text} align={"center"} />;
    }

    return text;
  }

  getSamlUrl(provider) {
    const params = new URLSearchParams(this.props.location.search);
    const clientId = params.get("client_id");
    const application = params.get("state");
    const realRedirectUri = params.get("redirect_uri");
    const redirectUri = `${window.location.origin}/callback/saml`;
    const providerId = provider.uid;
    const relayState = `${clientId}&${application}&${providerId}&${realRedirectUri}&${redirectUri}`;
    AuthBackend.getSamlLogin(`${provider.owner}/${providerId}`, btoa(relayState)).then((res) => {
      if (res.data2 === "POST") {
        document.write(res.data);
      } else {
        window.location.href = res.data;
      }
    });
  }

  renderProviderLogo(provider, application, width, margin, size, aStyle) {
    if (size === "small") {
      if (provider.category === "OAuth") {
        return (
          <a style={aStyle} key={provider.displayName} href={Provider.getAuthUrl(application, provider, "signup")}>
            <img
              width={width}
              height={width}
              src={Setting.getProviderLogoURL(provider)}
              alt={provider.displayName}
              style={{margin: margin}}
            />
          </a>
        );
      } else if (provider.category === "SAML") {
        return (
          <a style={aStyle} key={provider.displayName} onClick={this.getSamlUrl.bind(this, provider)}>
            <img
              width={width}
              height={width}
              src={Setting.getProviderLogoURL(provider)}
              alt={provider.displayName}
              style={{margin: margin}}
            />
          </a>
        );
      }
    } else {
      return (
        <div key={provider.displayName} style={{marginBottom: "10px"}}>
          <a href={Provider.getAuthUrl(application, provider, "signup")}>
            {this.getSigninButton(provider.type)}
          </a>
        </div>
      );
    }
  }

  isProviderVisible(providerItem) {
    if (this.state.mode === "signup") {
      return Setting.isProviderVisibleForSignUp(providerItem);
    } else {
      return Setting.isProviderVisibleForSignIn(providerItem);
    }
  }

  renderForm(application, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck) {
    if (this.state.msg !== null) {
      return Util.renderMessage(this.state.msg);
    }
    if (this.state.mode === "signup" && !application.enableSignUp) {
      return (
        <Result
          status="error"
          title="Sign Up Error"
          subTitle={"The application does not allow to sign up new account"}
          extra={[
            <Link
              onClick={() => {
                Setting.goToLogin(this, application);
              }}
              key="form"
            >
              <Button type="primary" key="signin">
                Sign In
              </Button>
            </Link>,
          ]}
        ></Result>
      );
    }

    if (application.enablePassword) {
      let usernameMsg = "",
        usernamePlaceholder = "";
      if (this.state.isPasswordSignin) {
        usernameMsg = i18next.t("login:Please input your username, Email or phone!");
        usernamePlaceholder = i18next.t("login:username, Email or phone");
      } else if (this.state.isPhoneSignin) {
        usernameMsg = i18next.t("login:Please input your phone!");
        usernamePlaceholder = i18next.t("login:Please input phone");
      } else if (this.state.isEmailSignin) {
        usernameMsg = i18next.t("login:Please input your email!");
        usernamePlaceholder = i18next.t("login:Please input email");
      }

      return (
        <Form
          name="normal_login"
          initialValues={{
            organization: application.organization,
            application: application.uid,
            autoSignin: true,
          }}
          onFinish={(values) => {
            if (this.state.isPasswordSignin) {
              this.onFinish(values, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, false);
              return;
            }
            this.onFinish(values, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck);
          }}
          style={this.isMobile() ? {} : {width: isSmallScreen ? 280 : 372}}
          size="large"
          labelCol={{span: 20, offset: 32}}
          ref={this.formRef}
        >
          <Form.Item
            style={{height: 0, visibility: "hidden", display: "none"}}
            name="application"
            rules={[
              {
                required: true,
                message: i18next.t("login:Please input your application!"),
              },
            ]}
          ></Form.Item>
          <Form.Item
            style={{height: 0, visibility: "hidden", display: "none"}}
            name="organization"
            rules={[
              {
                required: true,
                message: i18next.t("login:Please input your organization!"),
              },
            ]}
          ></Form.Item>
          <Form.Item
            name="username"
            style={this.isMobile() ?
              {height: 44, fontSize: 14, marginBottom: 22}
              :
              {marginBottom: 32, height: isSmallScreen ? 30 : 40}}
            rules={[
              {
                required: true,
                message: usernameMsg,
              },
              {
                validator: (_, value) => {
                  if (value === undefined || value === "") {
                    return Promise.resolve();
                  }

                  if (value.length > 50) {
                    return Promise.reject(
                      i18next.t("general:Limited number of characters is {number}").replace("{number}", 50)
                    );
                  }
                  if (this.state.isPhoneSignin && !Setting.isValidPhone(this.state.username)) {
                    this.setState({validEmailOrPhone: false});
                    return Promise.reject(
                      i18next.t("login:The input is not valid Phone!")
                    );
                  }
                  if (this.state.isEmailSignin && !Setting.isValidEmail(this.state.username)) {
                    this.setState({validEmailOrPhone: false});
                    return Promise.reject(
                      i18next.t("login:The input is not valid Email!")
                    );
                  }
                  if (this.state.isPhoneSignin && Setting.isValidPhone(this.state.username)) {
                    this.setState({validPhone: true});
                  }
                  if (this.state.isEmailSignin && Setting.isValidEmail(this.state.username)) {
                    this.setState({validEmail: true});
                  }
                  this.setState({validEmailOrPhone: true});
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder={usernamePlaceholder}
              disabled={!application.enablePassword}
              onChange={(e) => {
                this.setState({
                  username: e.target.value,
                });
              }}
            />
          </Form.Item>
          {!this.state.isPasswordSignin ? (
            <Form.Item
              name="code"
              style={this.isMobile() ?
                {height: 44, marginBottom: 0}
                :
                {marginBottom: 20, height: isSmallScreen ? 30 : 40}}
              rules={[
                {required: true, message: i18next.t("login:Please input your code!")},
                {
                  validator: (_, value) => {
                    if (value !== undefined && value.length > 6) {
                      return Promise.reject(
                        i18next.t("general:Limited number of characters is {number}").replace("{number}", 6)
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <CountDownInput
                disabled={this.state.username?.length === 0 || !this.state.validEmailOrPhone}
                onButtonClickArgs={[
                  this.state.username,
                  this.state.validEmail ? "email" : "phone",
                  Setting.getApplicationName(application),
                ]}
                application={application}
                from="login"
              />
            </Form.Item>
          ) : (
            <Form.Item
              name="password"
              style={this.isMobile() ?
                {height: 44, marginBottom: 0}
                :
                {marginBottom: 20, height: isSmallScreen ? 30 : 40}}
              getValueFromEvent = {
                (event) => {
                  return event.target.value.replace(/[\u4E00-\u9FA5]/g, "");
                }
              }
              rules={[{required: true, message: i18next.t("login:Please input your password!")}]}
            >
              <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder={i18next.t("login:Password")}
                disabled={!application.enablePassword}
              />
            </Form.Item>
          )}
          <Form.Item
            style={this.isMobile() ?
              {height: 40, fontSize: 13}
              :
              {marginBottom: isSmallScreen ? 20 : 35, height: isSmallScreen ? 30 : 40}}
          >
            {this.isMobile() || !application.enableAutoSignin ? null : <Form.Item name="autoSignin" valuePropName="checked" noStyle>
              <Checkbox style={{float: "left", fontSize: isSmallScreen ? 14 : 20, color: "#434343"}} disabled={!application.enablePassword}>
                {i18next.t("login:Auto sign in")}
              </Checkbox>
            </Form.Item>
            }
            {
              !application.organizationObj?.needActivation ? null :
                <a
                  style={this.isMobile() ?
                    {float: "left", fontSize: 13}
                    :
                    {float: "left", fontSize: isSmallScreen ? 14 : 20}}
                  onClick={() => {
                    const encode = Util.encodeUrl(window.location.href);
                    Setting.goToActivate(this, application, `?login_url=${encode}`);
                  }}
                >
                  {i18next.t("login:Account Activate")}
                </a>
            }
            <a
              style={this.isMobile() ?
                {float: "right", fontSize: 13}
                :
                {float: "right", fontSize: isSmallScreen ? 14 : 20}}
              onClick={() => {
                const zip = Util.encodeUrl(window.location.href);
                Setting.goToForget(this, application, `?login_url=${zip}`);
              }}
            >
              {i18next.t("login:Forgot password?")}
            </a>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={this.isMobile() ?
                {height: 44, fontSize: 17, width: "100%", backgroundColor: "#2078FF", borderRadius: 3}
                :
                {width: "100%", height: isSmallScreen ? 36 : 48, fontSize: isSmallScreen ? 16 : 24,
                  background: "linear-gradient(135deg, #246DEA 0%, #4194FC 100%)"}}
              disabled={!application.enablePassword}
            >
              {i18next.t("login:Sign In")}
            </Button>
            {/* {!application.enableSignUp ? null : this.renderFooter(application)} */}
            {this.renderFormFooter(application)}
          </Form.Item>
        </Form>
      );
    } else {
      return (
        <div style={{marginTop: "20px"}}>
          <div style={{fontSize: 16, textAlign: "left"}}>
            {i18next.t("login:To access")}&nbsp;
            <a target="_blank" rel="noreferrer" href={application.homepageUrl}>
              <span style={{fontWeight: "bold"}}>{application.displayName}</span>
            </a>
            :
          </div>
          <br />
          {application.providers
            .filter((providerItem) => this.isProviderVisible(providerItem))
            .map((providerItem) => {
              return this.renderProviderLogo(providerItem.provider, application, 40, 10, "big");
            })}
          {!application.enableSignUp ? null : (
            <div>
              <br />
              {this.renderFooter(application)}
            </div>
          )}
        </div>
      );
    }
  }

  renderFormFooter(application) {
    const iconButtonStyle = {
      width: 40,
      height: 40,
      borderRadius: 8,
      padding: "2px 0 0 0",
      borderColor: "rgba(0, 0, 0, 0.08)",
      marginRight: 10,
    };
    const colorBlue = "#08B14C", colorGreen = "#2078FF", colorYellow = "#EB8A14";

    return (
      <div style={{display: "flex", flexDirection: "row",
        alignItems: "center", marginTop: isSmallScreen ? 12 : 20}}>
        {
          !application.enablePassword ? null :
            <Button className={`login-icon-hover-green ${this.state.isPasswordSignin ? "login-icon-selected-green" : ""}`} style={iconButtonStyle}
              icon={<IconFont.LoginPwdIcon style={{color: colorBlue, fontSize: 22}} />}
              onClick={() => {
                this.setState({
                  isPasswordSignin: true,
                  isPhoneSignin: false,
                  isEmailSignin: false,
                });
                this.formRef.current.validateFields();
              }}
            >
            </Button>
        }
        {
          !application.enablePhoneCodeSignin ? null :
            <Button className={`login-icon-hover-blue ${this.state.isPhoneSignin ? "login-icon-selected-blue" : ""}`} style={iconButtonStyle}
              icon={<IconFont.LoginSmsIcon style={{color: colorGreen, fontSize: 22}} />}
              onClick={() => {
                this.setState({
                  isPasswordSignin: false,
                  isPhoneSignin: true,
                  isEmailSignin: false,
                });
                this.formRef.current.validateFields();
              }} >
            </Button>
        }
        {
          !application.enableEmailCodeSignin ? null :
            <Button className={`login-icon-hover-yellow ${this.state.isEmailSignin ? "login-icon-selected-yellow" : ""}`} style={iconButtonStyle}
              icon={<IconFont.LoginMailIcon style={{color: colorYellow, fontSize: 22}} />}
              onClick={() => {
                this.setState({
                  isPasswordSignin: false,
                  isPhoneSignin: false,
                  isEmailSignin: true,
                });
                this.formRef.current.validateFields();
              }}>
            </Button>
        }
        {
          Setting.isMobile() ? null
            :
            application.providers
              .filter((providerItem) => this.isProviderVisible(providerItem))
              .map((providerItem) => {
                return (<div className="login-hover-blue" style={{border: "1px solid", display: "flex", justifyContent: "center", alignItems: "center", ...iconButtonStyle}} key={providerItem.uid}>
                  {this.renderProviderLogo(providerItem.provider, application, 22, "0, 0, 0, 0", "small", {width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"})}
                </div>);
              })
        }
      </div>
    );
  }

  renderFooter(application) {
    if (this.state.mode === "signup") {
      return (
        <div style={{float: "right"}}>
          {i18next.t("signup:Have account?")}&nbsp;
          <Link
            onClick={() => {
              Setting.goToLogin(this, application);
            }}
          >
            {i18next.t("signup:sign in now")}
          </Link>
        </div>
      );
    } else {
      return (
        <React.Fragment>
          <span style={{float: "left"}}>
            {!application.enableCodeSignin ? null : (
              <a
                onClick={() => {
                  this.setState({
                    isCodeSignin: !this.state.isCodeSignin,
                  });
                }}
              >
                {this.state.isCodeSignin
                  ? i18next.t("login:Sign in with password")
                  : i18next.t("login:Sign in with code")}
              </a>
            )}
          </span>
          <span style={{float: "right"}}>
            {i18next.t("login:No account?")}&nbsp;
            <a
              onClick={() => {
                sessionStorage.setItem("loginURL", window.location.href);
                Setting.goToSignup(this, application);
              }}
            >
              {i18next.t("login:sign up now")}
            </a>
          </span>
        </React.Fragment>
      );
    }
  }

  renderSignedInBox(updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck) {
    if (this.props.account === undefined || this.props.account === null) {
      return null;
    }
    const application = this.getApplicationObj();

    if (this.props.account.owner !== application.organization) {
      return null;
    }

    const params = new URLSearchParams(this.props.location.search);
    const silentSignin = params.get("silentSignin");
    if (silentSignin !== null) {
      if (window !== window.parent) {
        const message = {tag: "Casdoor", type: "SilentSignin", data: "signing-in"};
        window.parent.postMessage(message, "*");
      }

      // let values = {};
      // values["application"] = this.state.application.uid;
      // this.onFinish(values);
    }

    const values = {};
    values["application"] = this.state.application.uid;
    // values["username"] = this.props.account.name;
    this.onFinish(values, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, true, this.props.account.name);

    // return (
    //   <div>
    //     <div style={{ fontSize: 16, textAlign: "left", marginTop: "24px" }}>
    //       {i18next.t("login:Continue with")}&nbsp;:
    //     </div>
    //     <br />
    // <SelfLoginButton
    //   account={this.props.account}
    //   onClick={() => {
    //     let values = {};
    //     values["application"] = this.state.application.uid;
    //     this.onFinish(values);
    //   }}
    // />
    //     <br />
    //     <br />
    //     <div style={{ fontSize: 16, textAlign: "left" }}>
    //       {i18next.t("login:Or sign in with another account")}&nbsp;:
    //     </div>
    //   </div>
    // );

    return (
      // <div style={{display:"flex", flexDirection:"row", alignItems:"center", marginBottom: 19}}>
      //   <div style={{ fontSize: isSmallScreen ? 16 : 20, textAlign: "left", margin: "0", color:"#434343"}}>
      //     {i18next.t("login:Continue with")}&nbsp;:
      //   </div>
      //   <Button style={{fontSize: isSmallScreen ? 16 : 20, padding: 0, height: isSmallScreen ? 36 : 48}}
      //     type="link"
      //     onClick={() => {
      //       let values = {};
      //       values["application"] = this.state.application.uid;
      //       this.onFinish(values);
      //     }}>
      //      {/* {`${this.props.account.name} (${this.props.account.displayName})`} */}
      //    </Button>
      // </div>
      null
    );
  }

  renderSignFormLogo() {
    const styleDisplayname = {
      color: "#3B3B3B",
      margin: "0 0 0 16px",
      fontSize: isSmallScreen ? 20 : 26,
      fontWeight: 500,
    };
    const logo = {
      width: 32,
      height: 32,
    };
    const styleBox = {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    };

    return (
      <div style={styleBox}>
        <img
          src={require("../../assets/images/logo.png")}
          alt={i18next.t("login:Platform login")}
          style={logo}
        />
        <p style={styleDisplayname}>{i18next.t("login:Platform login")}</p>
      </div>
    );
  }

  renderSigninTips() {
    const styleTip = {
        color: "#4d4d4d",
        fontSize: 14,
        marginBottom: 8,
      },
      styleSigninTip = {
        fontSize: 12,
        color: "#767676",
        margin: 0,
      },
      browserDiv = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      browserIco = {
        marginLeft: isSmallScreen ? 14 : 27,
        width: 24,
        height: 24,
      },
      browserRecom = {
        margin: 0,
        fontSize: 14,
        color: "#4d4d4d",
      },
      browserName = {
        margin: "0 0 0 5px",
        fontSize: 12,
        color: "#767676",
      };
    return (
      <React.Fragment>
        <p style={styleTip}>{i18next.t("login:Sign in tips")}：</p>
        <p style={styleSigninTip}>{i18next.t("login:Sign in tip1")}</p>
        <p style={styleSigninTip}>{i18next.t("login:Sign in tip2")}</p>
        <div style={browserDiv}>
          <p style={browserRecom}>{i18next.t("login:Browser recommended")}：</p>
          <img style={browserIco} src={require("../../assets/images/chrome.png")} alt={i18next.t("login:Chrome")} />
          <p style={browserName}>{i18next.t("login:Chrome")}</p>
          <img style={browserIco} src={require("../../assets/images/firefox.png")} alt={i18next.t("login:Firefox")} />
          <p style={browserName}>{i18next.t("login:Firefox")}</p>
          <img style={browserIco} src={require("../../assets/images/360.png")} alt={i18next.t("login:360")} />
          <p style={browserName}>{i18next.t("login:360")}</p>
        </div>
      </React.Fragment>
    );
  }

  renderLogo(application) {
    // 禁止点击
    application.homepageUrl = null;
    if (application === null) {
      return null;
    }

    const styleDisplayname = {
        color: "#fff",
        marginLeft: 21,
        fontSize: isSmallScreen ? 20 : 24,
      },
      styleLogo = {width: isSmallScreen ? 36 : 48, height: isSmallScreen ? 36 : 48};

    if (application.homepageUrl !== "") {
      return (
        <a
          target="_blank"
          rel="noreferrer"
          href={application.homepageUrl}
          style={{display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "10%"}}
        >
          {
            application.systemLogo === "" ?
              <img
                src={application.logo === "" ? require("../../assets/images/default_icon_white.png") : application.logo}
                alt={application.displayName}
                style={styleLogo}
              />
              :
              <Col>
                <li className="icon-container" style={{width: isSmallScreen ? 36 : 48, height: isSmallScreen ? 36 : 48}}
                >
                  <span className={["app-icon", `${iconfont.font_family} ${iconfont.css_prefix_text}${application.systemLogo}`].join(" ")}
                    style={{width: isSmallScreen ? 36 : 48, height: isSmallScreen ? 36 : 48, fontSize: isSmallScreen ? 36 : 48, color: "#fff"}}></span>
                </li>
              </Col>
          }
          <span style={styleDisplayname}>{application.displayName}</span>
        </a>
      );
    } else {
      return (
        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
          {
            application.systemLogo === "" ?
              <img
                src={application.logo === "" ? require("../../assets/images/default_icon_white.png") : application.logo}
                alt={application.displayName}
                style={styleLogo}
              />
              :
              <Col>
                {
                  <li className="icon-container" style={{width: 48, height: 48}}
                  >
                    <span className={["app-icon", application.sysLogoBg].join(" ")} style={{width: 40, height: 40, fontSize: isSmallScreen ? 20 : 32}}></span>
                  </li>
                }
              </Col>
          }
          <p style={styleDisplayname}>{application.displayName}</p>
        </div>
      );
    }
  }

  render() {
    const application = this.getApplicationObj();
    if (application === null) {
      return Util.renderMessageLarge(this, Setting.getResponseMessage(this.state.msg), () => {
        window.history.back();
      });
    }
    if (this.state.casParamException) {
      return Util.renderMessageLarge(this, i18next.t("cas参数异常"), () => {
        window.history.back();
      });
    }

    if (application.signinHtml !== "") {
      return <div dangerouslySetInnerHTML={{__html: application.signinHtml}} />;
    }

    const visibleOAuthProviderItems = application.providers.filter((providerItem) =>
      this.isProviderVisible(providerItem)
    );
    if (
      this.props.application === undefined &&
      !application.enablePassword &&
      visibleOAuthProviderItems.length === 1
    ) {
      Setting.goToLink(
        Provider.getAuthUrl(application, visibleOAuthProviderItems[0].provider, "signup")
      );
      return (
        <div style={{textAlign: "center"}}>
          <Spin size="large" tip={i18next.t("login:Signing in...")} style={{paddingTop: "10%"}} />
        </div>
      );
    }

    /* 样式start */
    const antCol24 = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100vw",
        background: `url(${
          require("../../assets/images/bg-login.png")
        }) center center no-repeat`,
        backgroundSize: "100% 100%",
      },
      antCol24Div = {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: isSmallScreen ? "28px 36px 24px 36px" : "48px 70px 35px 70px",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        marginRight: "9%",
        borderRadius: 10,
        boxShadow: "0px 4px 40px 0px rgba(45, 98, 147, 0.1)",
      },
      antCol24Head = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: "100%",
        background: `url(${
          require("../../assets/images/bg-logo-head.png")
        }) center center no-repeat`,
        backgroundSize: "cover",
      },
      leftBg = {
        height: "60vh",
        width: "56vw",
      },
      styleToggleLanguage = {
        fontSize: 13,
        backgroundColor: "rgba(252, 252, 252, 0.7)",
        color: "#2078FF",
        padding: "6px 10px",
        borderRadius: 3,
        marginRight: 24,
      };

    /* 移动端适配 */
    const antCol24Mobile = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        background: `url(${
          require("../../assets/images/building.png")
        }) center top no-repeat`,
        position: "relative",
      },
      antCol24DivMobile = {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        height: 390,
        width: "82.6%",
        boxSizing: "border-box",
        padding: "0 28px",
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderRadius: 8,
        boxShadow: "4px 4px 24px 0px rgba(54, 85, 141, 0.1)",
        position: "relative",
      },
      styleDisplaynameMobile = {
        color: "#46494C",
        textAlign: "center",
        fontSize: 19,
        fontWeight: "bold",
        margin: 0,
      },
      styleLogoMobile = {
        position: "absolute",
        left: "calc(50% - 35px)",
        top: -35,
        border: "6px solid #fff",
        backgroundColor: "#fff",
        borderRadius: 41,
      },
      styleToggleLanguageMobile = {
        position: "absolute",
        top: 20,
        right: 16,
        fontSize: 13,
        backgroundColor: "rgba(252, 252, 252, 0.7)",
        color: "#2078FF",
        padding: "6px 16px",
        borderRadius: 3,
      };
    const menuBtn = <div style={styleToggleLanguage}>{i18next.t("language:Selected language")}</div>;
    const menuBtnMobile = <div style={styleToggleLanguageMobile}>{i18next.t("language:Selected language")}</div>;
    /* 样式end */
    return (
      <GlobalContext.Consumer>
        {
          ({updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck}) => (
            <>
              <>
                {this.isMobile() ?
                  <Row style={{
                    height: "100vh", width: "100vw",
                    background: "linear-gradient(to bottom, #349BFB, 40% , #ffffff)",
                  }}>
                    <Col span={24} style={antCol24Mobile}>
                      <SelectLanguageBox menuBtn={menuBtnMobile}></SelectLanguageBox>
                      <div style={antCol24DivMobile}>
                        {this.props?.isPreview ? null
                          :
                          Setting.renderHelmet(application)}
                        <img src={require("../../assets/images/logo_mobile.png")} alt="" style={styleLogoMobile} />
                        <div style={{width: "100%", marginTop: 63, marginBottom: 34}}>
                          <p style={styleDisplaynameMobile}>{i18next.t("login:Platform login")}</p>
                        </div>
                        {this.renderSignedInBox(updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck)}
                        {this.renderForm(application, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck)}
                      </div>
                    </Col>
                  </Row>
                  :
                  <React.Fragment>
                    <Row style={{height: isSmallScreen ? 44 : 76}}>
                      <Col span={24} style={antCol24Head}>
                        {this.renderLogo(application)}
                        <SelectLanguageBox menuBtn={menuBtn}></SelectLanguageBox>
                      </Col>
                    </Row>
                    <Row style={{height: isSmallScreen ? "calc(100vh - 50px)" : "calc(100vh - 76px)"}}>
                      <Col span={24} style={antCol24}>
                        <div style={{flexGrow: 1, textAlign: "center"}}>
                          <img src={require("../../assets/images/login_bg_left.png")} alt="" style={leftBg} />
                        </div>
                        <div style={antCol24Div}>
                          {this.props?.isPreview ? null
                            :
                            Setting.renderHelmet(application)}
                          <CustomGithubCorner />
                          <div style={{marginBottom: isSmallScreen ? 20 : 38, width: "100%"}}>
                            {this.renderSignFormLogo()}
                          </div>
                          {/* {*/}
                          {/*  this.state.clientId !== null ? "Redirect" : null*/}
                          {/* }*/}
                          {this.renderSignedInBox()}
                          {this.renderForm(application, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck)}
                          <img
                            alt=""
                            src={require("../../assets/images/logo.png")}
                            style={{display: "none"}} />
                          <img
                            alt=""
                            src={require("../../assets/images/web.ico")}
                            style={{display: "none"}} />
                          {this.renderSigninTips()}
                        </div>
                      </Col>
                    </Row>
                  </React.Fragment>}
              </>
              <Captcha
                application={application}
                onRef={this.captchaRef}
                handleConfirm={() => {
                  this.onFinish(this.formRef.current.getFieldsValue(true), updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, true);
                }} />
            </>
          )
        }
      </GlobalContext.Consumer>
    );
  }
}

export default LoginPage;
